<template>
  <div class="flex">
    <!-- Sidebar -->
    <SidebarComponent />

    <!-- Conținut principal -->
    <div class="flex-1 p-8 text-text-light">
      <!-- Titlu -->
      <h1 class="text-3xl font-bold mb-6 text-accent-light">Lista Membrilor</h1>

      <!-- Total Membri -->
      <div class="bg-info-dark p-2 rounded mb-4 text-center text-white font-semibold">
        Membri: {{ members.length }} / 250
      </div>

      <!-- Căutare -->
      <input v-model="searchTerm" placeholder="Caută după nickname..."
        class="w-full p-2 mb-4 rounded bg-primary-dark text-white" />

      <!-- Tabel -->
      <div class="overflow-x-auto bg-primary-dark p-4 rounded">
        <table class="w-full text-left text-sm rounded overflow-hidden">
          <thead>
            <tr class="text-white bg-accent-dark">
              <th class="p-2">Discord ID</th>
              <th class="p-2">Nickname</th>
              <th class="p-2">Grad</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(member, index) in sortedAndFilteredMembers" :key="member.discordID"
              :class="index % 2 === 0 ? 'bg-row-light' : 'bg-row-dark'">
              <td class="p-2">{{ member.discordID }}</td>
              <td class="p-2">{{ member.discord_name }}</td>
              <td class="p-2">{{ member.grad || 'Nespecificat' }}</td>
            </tr>
            <tr v-if="sortedAndFilteredMembers.length === 0">
              <td colspan="3" class="p-4 text-center">Nu au fost găsiți membri.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <!-- Footer -->
  <FooterComponent />
</template>

<script>
import apiClient from "@/api/axiosInstance"; // Importăm instanța Axios configurată
import SidebarComponent from "../components/SidebarComponent.vue";
import FooterComponent from "@/components/FooterComponent.vue";

export default {
  name: "MembersView",
  components: { SidebarComponent, FooterComponent },
  data() {
    return {
      members: [], // Datele membrilor
      searchTerm: "", // Termenul de căutare
    };
  },
  computed: {
    // Sortare și filtrare membri
    sortedAndFilteredMembers() {
      return this.members
        .filter((member) =>
          member.discord_name.toLowerCase().includes(this.searchTerm.toLowerCase())
        )
        .sort((a, b) => {
          // Sortare după discord_name
          return a.discord_name.localeCompare(b.discord_name);
        });
    },
  },
  created() {
    this.fetchMembers();
  },
  methods: {
    // Fetch date din SQL prin API cu token
    async fetchMembers() {
      try {
        // Actualizare: apelăm endpoint-ul "/api/membri" pentru a se potrivi cu backend-ul
        const response = await apiClient.get("/api/membri", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        console.log("Data primită de la API:", response.data); // Verifică ce date primești
        this.members = response.data; // Setăm datele preluate
      } catch (error) {
        console.error("Eroare la preluarea membrilor:", error);
      }
    },
  },
};
</script>

<style scoped>
.text-text-light {
  color: #b3b3cc;
}

.text-accent-light {
  color: #a855f7;
}

.bg-primary-dark {
  background-color: #1a1528;
}

.bg-accent-dark {
  background-color: #a855f7;
}

.bg-info-dark {
  background-color: #6b21a8;
}

.bg-row-light {
  background-color: #262642;
}

.bg-row-dark {
  background-color: #1e1e36;
}

input {
  border: 1px solid #444;
}
</style>
